import React from 'react';

import linkSvg from '@assets/img/icons/link.svg';
import { makeMuiStyles } from '@styles/index';
import { url } from '@utils/pages';
import { stringify } from 'query-string';
import { Link } from 'react-router-dom';

const useStyles = makeMuiStyles((theme, common) => ({
  SelectItemLabelIcon: {
    ...common.flexInline,
    filter: 'opacity(0.5)',
    '&:hover': {
      filter: 'opacity(1)',
    },
  },
}));

export const PartnerLink: React.FC<{ partnerId: number }> = ({ partnerId }) => {
  const classes = useStyles();

  return (
    <Link
      to={{
        pathname: url('/admin/widgets/PartnerDetails'),
        search: stringify({
          id: partnerId,
        }),
      }}
      target="_blank"
      className={classes.SelectItemLabelIcon}
      onClick={(e) => e.stopPropagation()}
    >
      <img src={linkSvg} alt="link" />
    </Link>
  );
};
